export const industrySector = [
  "Administrator", "Assembly Worker", "FLT Bendi Driver", "Call Centre", "Class 1", "Class 2", "Cleaning", "7.5t", 
  "Van", "Credit Controller", "CSCS Card", "Customer Services", "Despatch", "Distribution", "Dock Pass", 
  "Drivers Mate", "2nd Man", "FLT", "FLT Counterbalance", "FLT Reach", "FLT Pivot Steer", "FLT PPT", 
  "H.I.A.B", "Handballer", "Labourer", "Load Shovel Driver", "Logistics", "Machine Op", "Manager", 
  "Manufacturing", "Merchandiser", "Office", "Office Assistant", "Packing", "Parcel Sorter", "Picking", 
  "Pivot Steer", "Porter", "Production Op", "Quality Control", "Quality Inspector", "Receptionist", 
  "Recycling Op", "Retail", "Retail Assistant", "Rough Terrain", "Sales", "Security", "Sewing", 
  "Sheet Metal Worker", "Sliver Service", "Sorter", "Stock Control", "Stock Counter", "Telescopic Handler", 
  "Traffic Operative", "Transport Planner", "VNA Driver", "Waiting On", "Waitress", "Warehouse Op", 
  "Welder"
];